export const roundToPrecision = (num, decPlaces) => {
  const decimalPlacesOperator = 10 ** Math.abs(decPlaces);
  return decPlaces >= 1
    ? Math.round(num)
    : Math.round(num * decimalPlacesOperator) / decimalPlacesOperator;
};

export const average = (array) => array.reduce((a, b) => a + b) / array.length;
